import script from "./MenuNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MenuNavigation.vue?vue&type=style&index=0&id=766ab7a5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766ab7a5"]])

export default __exports__